import React from 'react';

import Alerts from '@/comp/StationControlCenter/ControlCenterCompressorWidget/Alerts';
import { AlertsBarContainer } from './AlertsBar.styles';

interface AlertsBarProps {
  activeOpenAlerts: unknown[];
}

export const AlertsBar = ({ activeOpenAlerts }: AlertsBarProps) => (
  <AlertsBarContainer>
    <div className="alerts-container">
      <Alerts activeOpenAlerts={activeOpenAlerts} />
    </div>
  </AlertsBarContainer>
);
